import { Eye, Heart, HourglassSimple, Prohibit, SealCheck, Star } from "@phosphor-icons/react";
import { useSeo, useSite } from "@/hooks/useSite";
import { Band, GlassIcon, Heading, IconTile, PageHero, SitePage } from "@/components/site/SiteBits";
import { ChatsScreen, CrushesScreen, DiscoverScreen, Phone } from "@/components/site/Phones";

const Glass = (p) => <GlassIcon size={22} {...p} />;
const SECTIONS = [
  { n: 1, icons: [Heart, Star, Prohibit], screen: <DiscoverScreen /> },
  { n: 2, icons: [Glass, Eye], screen: <CrushesScreen /> },
  { n: 3, icons: [HourglassSimple, SealCheck], screen: <ChatsScreen /> },
];

function Tiles({ tiles }) {
  return (
    <ul className="mt-14 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6" data-testid="how-tiles">
      {tiles.map((t) => (
        <li key={t.key} className="s-card p-5 text-center" data-testid={`how-tile-${t.key}`}>
          <p className="s-coral text-3xl font-bold tracking-tight tabular-nums">{t.value_text || t.value}</p>
          <p className="s-muted mt-2 text-[0.8125rem] leading-5">{t.label}</p>
        </li>))}
    </ul>
  );
}

function Step({ f, n, icons, screen, flip }) {
  const k = `s${n}`;
  const points = [1, 2, 3].map((i) => ({ title: f[`${k}_p${i}_title`], line: f[`${k}_p${i}_line`] })).filter((p) => p.title);
  if (!f[`${k}_title`]) return null;
  return (
    <section className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20" data-testid={`how-section-${n}`}>
      <div className={flip ? "lg:order-2" : ""}>
        <p className="s-coral text-sm font-bold tabular-nums">{f[`${k}_num`]}</p>
        <Heading title={f[`${k}_title`]} accent={f[`${k}_accent`]} className="s-h2 mt-3" />
        {f[`${k}_body`] && <p className="s-muted mt-5 text-lg leading-8">{f[`${k}_body`]}</p>}
        <ul className="mt-8 space-y-6">
          {points.map((p, i) => <li key={i} className="flex gap-4"><IconTile icon={icons[i] || Heart} /><div><h3 className="font-bold">{p.title}</h3><p className="s-muted mt-1 leading-6">{p.line}</p></div></li>)}
        </ul>
      </div>
      <div className={`hidden justify-center lg:flex ${flip ? "lg:order-1" : ""}`}><Phone tilt={flip ? "s-tilt-left" : "s-tilt"} testId={`how-phone-${n}`}>{screen}</Phone></div>
    </section>
  );
}

export default function HowItWorks() {
  const { data, error, loading, reload } = useSite();
  const f = data?.docs?.site_how?.fields || {};
  useSeo("How it works", f.hero_lead);
  return (
    <SitePage loading={loading} error={error} onRetry={reload} testId="how-page">
      <PageHero chip={f.hero_chip} title={f.hero_title} accent={f.hero_accent} lead={f.hero_lead} center testId="how-hero" />
      <Tiles tiles={data?.how_tiles || []} />
      <div className="mt-24 space-y-28">{SECTIONS.map((s, i) => <Step key={s.n} f={f} {...s} flip={i % 2 === 1} />)}</div>
      <Band title={f.band_title} accent={f.band_accent} line={f.band_line} button={f.band_button} testId="how-band" />
    </SitePage>
  );
}
